import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import InactiveObjectBadge from "components/ui/InactiveObjectBadge";

interface ReportObjectNameCellProps {
  name?: string | null;
  isInactive?: boolean;
  fontSize?: string;
  fontWeight?: number;
}

const ReportObjectNameCell: FC<ReportObjectNameCellProps> = ({
  name,
  isInactive = false,
  fontSize = "14px",
  fontWeight = 500
}) => {
  return (
    <Stack alignItems="flex-start" spacing={0.5}>
      {isInactive ? <InactiveObjectBadge variant="inline" /> : null}
      <Typography
        sx={{
          fontSize,
          fontWeight,
          color: isInactive ? "#646D7B" : "inherit"
        }}
      >
        {name || "N/A"}
      </Typography>
    </Stack>
  );
};

export default ReportObjectNameCell;
